module.exports = __webpack_public_path__ + "static/media/refil-noblesse.ded7fe3c.webp";